import * as React from 'react';
import colors from '../../../../../../config/theme/colors';
import { fm } from 'Components/FormatMessage';
import InputHandler from 'Components/InputHandler';
import type { IExtendedSearchField } from '../ExtendedSearchField';

const TirednessOrNearMissWhileDrivingField = ({ searchFields, onChange }: IOwnProps): React.JSX.Element => {
  const thisField = 'tirednessOrNearMissWhileDrivingDuringLast12Months';
  const optionsByCriteria = {
    sleepApneaFirstVisitInquiry: ['often', 'sometimes', 'oftenOrSometimes', 'never'],
    deviceTherapyControlVisitInquiry: ['yes', 'no'],
  };

  const handleChange = (values: TOnChangeValues): void => {
    const thisName = Object.keys(values)[0] as 'sleepApneaFirstVisitInquiry' | 'deviceTherapyControlVisitInquiry';
    let thisValue = values[thisName];
    const baseValue = typeof searchFields[thisField] === 'object' ? searchFields[thisField] : {};

    if (typeof thisValue === 'boolean') thisValue = thisValue === true ? optionsByCriteria[thisName][0] : undefined;

    let newValues: { [key: string]: unknown } | 'noCropping' = { ...baseValue, [thisName]: thisValue };

    if (!newValues?.sleepApneaFirstVisitInquiry && !newValues?.deviceTherapyControlVisitInquiry) {
      newValues = 'noCropping';
    }

    onChange({
      [thisField]: newValues,
    });
  };

  return (
    <React.Fragment>
      {(
        ['sleepApneaFirstVisitInquiry', 'deviceTherapyControlVisitInquiry'] as (
          | 'sleepApneaFirstVisitInquiry'
          | 'deviceTherapyControlVisitInquiry'
        )[]
      ).map((f, i, arr) => (
        <React.Fragment key={`${f}.${i}`}>
          <div
            style={{
              backgroundColor: colors.lightestGray,
              padding: '1rem',
              marginBottom: i === arr.length - 1 ? '1rem' : undefined,
            }}
          >
            <div style={{ marginBottom: '1rem', color: colors.tertiaryText }}>
              {fm('extendedSearch.searchCriteriaTitle')}
              {` ${i + 1}`}
            </div>
            <InputHandler
              type="CheckboxSingle"
              editing={true}
              name={f}
              formData={{
                onChange: handleChange,
                document: {
                  [f]:
                    searchFields[thisField] !== 'noCropping' && searchFields[thisField][f] !== undefined
                      ? true
                      : undefined,
                },
              }}
              option="true"
              optionFormatter={(): string | React.JSX.Element => fm(`extendedSearch.opts.${f}`)}
              showLabel
            />
            <div style={{ marginBottom: '1rem', color: colors.tertiaryText }}>
              {fm('extendedSearch.tirednessOrNearMissWhileDriving')}
            </div>
            <InputHandler
              type="Radio"
              editing={true}
              name={f}
              formData={{
                onChange: handleChange,
                document: {
                  [f]: searchFields[thisField] !== 'noCropping' ? searchFields[thisField][f] : undefined,
                },
              }}
              options={optionsByCriteria[f]}
              optionFormatter={(name: string | number): string | React.JSX.Element => fm(`extendedSearch.opts.${name}`)}
              disabledOptions={
                typeof searchFields[thisField] !== 'object' || !searchFields[thisField][f]
                  ? optionsByCriteria[f]
                  : undefined
              }
            />
          </div>
          {i === 0 && <div style={{ padding: '1rem', textTransform: 'uppercase' }}>{fm('general.or')}</div>}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

interface IOwnProps extends Pick<IExtendedSearchField, 'searchFields' | 'onChange'> {}

export default TirednessOrNearMissWhileDrivingField;
